"use client"; // Error components must be Client Components

import ErrorComponent from "@/components/layout/ErrorComponent";

export default function Error() {
  return <ErrorComponent />;
}
